module.exports = __webpack_public_path__ + "img/SFA Event4.8baa0389.jpeg";